import { IEnvironment } from './models/environment.model';
import { createProxy } from './utils/create-proxy.util';
export const environment = createProxy({} as IEnvironment);
